import React from 'react';
import moment from 'moment';

import EventIcon from './event-icon';
import style from './index.less';

const MessageEventEvalution = props => {
  const { data } = props;
  const { action, content, time } = data;
  const date = moment
    .utc(time)
    .local()
    .format('MM/DD HH:mm:ss');

  return (
    <div className={style['event-box']}>
      <ul className={style.header}>
        <li>
          <EventIcon action={action} />
        </li>
        <li className={style.date}>{date}</li>
        <li>顾客</li>
        <li>成功提交字段</li>
      </ul>
      <div className={style['event-border']} />
      <div className={style['evaluation-content']}>
        {content.map(item => {
          const { label, value } = item;
          const text = value === 0 || value ? value : '-';
          return (
            <div key={`${label}_${label}`}>
              {label}：{text}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MessageEventEvalution;
